/* eslint-disable jsx-a11y/no-autofocus */

import React from 'react';
import { connect } from 'react-redux';
import pt from 'prop-types';
import actions from 'partners/actions';
import { Form, Field } from 'components/form';
import Modal from 'components/modal';
import { slugify } from 'utils';
import './CreateStore.scss';

const mapDispatchToProps = (dispatch) => ({
  validateClient: (data) => {
    return dispatch(actions.client.validate(data));
  },

  flashError: (message) => {
    dispatch(actions.flash.error(message));
  },
});

class CreateStore extends React.PureComponent {
  static propTypes = {
    title: pt.string,
    action: pt.string,
    width: pt.number,
    validateClient: pt.func,
    flashError: pt.func,
    onSubmit: pt.func,
    onCancel: pt.func,
    devStoreCount: pt.number,
    devStoreLimit: pt.number,
  };

  static contextTypes = {
    closeModal: pt.func.isRequired,
  };

  validateStoreNameTimer = null;

  constructor(props) {
    super(props);

    this.state = {
      name: null,
      errors: {},
      loading: false,
    };
  }

  onChangeStoreName = (_event, name) => {
    const { flashError, validateClient } = this.props;
    const { errors } = this.state;

    clearTimeout(this.validateStoreNameTimer);

    this.setState({
      name,
      errors: {
        ...errors,
        name: undefined,
      },
    });

    if (!name) {
      return;
    }

    this.validateStoreNameTimer = setTimeout(async () => {
      const result = await validateClient({
        store_name: name,
      });

      if (!result) {
        flashError('Something went wrong!');
      } else if (result.errors) {
        this.setState({
          errors: {
            ...errors,
            name: result.errors.store_name,
          },
        });
      }
    }, 500);
  };

  onSubmitForm = async ({ name }) => {
    const { onSubmit } = this.props;

    if (onSubmit) {
      this.setState({ loading: true });

      const result = await onSubmit(name);

      this.setState({ loading: false });

      if (!result) {
        return;
      }
    }

    this.context.closeModal();
  };

  onClickCancel = (event) => {
    event.preventDefault();

    this.props.onCancel?.();
    this.context.closeModal();
  };

  render() {
    const {
      title = 'Create a development store',
      action = 'Create store',
      width = 760,
      devStoreCount,
      devStoreLimit,
    } = this.props;
    const { name, errors, loading } = this.state;

    return (
      <Form onSubmit={this.onSubmitForm} autoFocus={true}>
        <Modal
          title={title}
          width={width}
          className="create-store-modal"
          actions={[
            {
              label: action,
              type: 'submit',
            },
            { label: 'Cancel', type: 'cancel', onClick: this.onClickCancel },
          ]}
          onClose={this.onClickCancel}
          cancel={false}
          closable={true}
          loading={loading}
        >
          <p className="create-store-modal-text">
            Development stores have all features of the Advanced plan, with no
            expiry. They can be used for staging and testing purposes, but do
            not support live transactions.
          </p>
          {devStoreCount !== null && devStoreCount !== undefined && (
            <p className="create-store-modal-count">
              You have {devStoreCount} of {devStoreLimit} development stores.
              Partners can have a maximum of {devStoreLimit}.
            </p>
          )}
          <fieldset>
            <Field
              type="text"
              name="name"
              label="Store name"
              required={true}
              maxLength={32}
              onChange={this.onChangeStoreName}
              error={errors.name}
            />
          </fieldset>
          <p className="create-store-modal-hint">
            https://<b>{name ? slugify(name) : 'your-store-name'}</b>
            .swell.store will be your store domain. This can’t be changed later.
          </p>
        </Modal>
      </Form>
    );
  }
}

export default connect(null, mapDispatchToProps)(CreateStore);
